<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات گروه ورزشی"
        >
          <b-form
              ref="activitygroupform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="8"
                  lg="6"
                  offset-md="2"
                  offset-lg="3"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="8">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                              label="شناسه"
                              label-for="Percent"
                              class="mb-0"
                          >
                            <b-form-input
                                id="IdInStore"
                                v-model="Form.IdInStore"
                                name="IdInStore"
                                autocomplete="off"
                                type="number"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                    </b-media>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="درصد"
                        label-for="Percent"
                    >
                      <b-form-input
                          id="Percent"
                          v-model="Form.Percent"
                          name="Percent"
                          autocomplete="off"
                          type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="درصد با رژیم"
                        label-for="Percent"
                    >
                      <b-form-input
                          id="ActivityPercent"
                          v-model="Form.ActivityPercent"
                          name="ActivityPercent"
                          autocomplete="off"
                          type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="وضعیت"
                        label-for="ActivationType"
                    >
                      <v-select
                          v-model="Form.ActivationType"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="ActivationType"
                          :clearable="false"
                          :options="enums('ActivationType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="ترتیب"
                        label-for="Sort"
                        class="mb-0"
                    >
                      <b-form-input
                          id="Sort"
                          v-model="Form.Sort"
                          name="Sort"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="عنوان در گوگل پلی"
                        label-for="UniversalPackageId"
                        class="mb-0"
                    >
                      <b-form-input
                          id="UniversalPackageId"
                          v-model="Form.UniversalPackageId"
                          name="UniversalPackageId"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                      cols="12"
                      class="mt-1 mb-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                          v-model="Form.JustFullSale"
                          name="JustFullSale"
                          value="true"
                          class="custom-control-success"
                      >
                        این گروه ورزشی به صورت کامل فروخته می شود و امکان خرید تکی دوره وجود ندارد!
                      </b-form-checkbox>

                      <b-form-checkbox
                          v-if="Form.JustFullSale === false"
                          v-model="Form.JustFullSale"
                          name="JustFullSale"
                          value="false"
                          style="display: none;"
                      />

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                        v-for="(item, index) in Form.ActivityGroupLanguage"
                        :key="index"
                    >

                      <b-col cols="12">
                        <hr>
                      </b-col>

                      <b-col cols="11">
                        <b-row>
                          <b-col md="3">
                            <b-form-group
                                label="زبان"
                            >
                              <z-language
                                  v-model="item.Language"
                                  :unselectable="Form.ActivityGroupLanguage.map(x => x.Language)"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                                label="عنوان"
                            >
                              <b-form-input
                                  v-model="item.Title"
                                  autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="5">
                            <b-form-group label="قیمت">
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  تومان
                                </b-input-group-prepend>
                                <cleave
                                    id="Price"
                                    v-model="item.Price"
                                    class="form-control"
                                    :raw="false"
                                    :options="options"
                                    autocomplete="off"
                                />
                              </b-input-group>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12">
                            <b-form-group
                                label="توضیحات"
                                label-for="Description"
                            >
                              <div class="form-label-group">
                                <b-form-textarea
                                    id="Description"
                                    v-model="item.Description"
                                    name="Description"
                                    autocomplete="off"
                                    rows="3"
                                    no-resize
                                />
                              </div>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12">
                            <b-form-group
                                label="توضیحات خرید"
                                label-for="PurchaseDescription"
                            >
                              <div class="form-label-group">
                                <b-form-textarea
                                    v-model="item.PurchaseDescription"
                                    name="PurchaseDescription"
                                    autocomplete="off"
                                    rows="3"
                                    no-resize
                                />
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                          cols="1"
                          style="display: flex; flex-direction: column;align-items: center;padding-top: 30px"
                      >
                        <template v-if="ActivityGroupLanguageRemoveId !== index">
                          <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="btn-icon rounded-circle"
                              size="sm"
                              @click="removeActivityGroupLanguage(index)"
                          >
                            <feather-icon
                                icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle"
                              variant="outline-primary"
                              size="sm"
                              @click="cancelActivityGroupLanguage"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle mt-1"
                              variant="outline-primary"
                              size="sm"
                              @click="confirmActivityGroupLanguage"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="gradient-info"
                        @click="addActivityGroupLanguage"
                    >
                      <feather-icon
                          icon="PlusIcon"
                          class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'ActivityGroupDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Sort: 0,
        ActivationType: 1,
        ActivityGroupLanguage: [],
        UniversalPackageId: ''
      },
      ActivityGroupLanguageRemoveId: null,
      loading: false,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 0,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addActivityGroupLanguage()
    }
  },
  methods: {
    save() {
      let url = this.$api.activitygroup.add
      if (this.$route.params.id) {
        url = this.$api.activitygroup.update
      }

      const formData = new FormData(this.$refs.activitygroupform)
      formData.append('Id', this.Form.Id)
      formData.append('ActivationType', this.Form.ActivationType)

      this.Form.ActivityGroupLanguage.forEach((item, index) => {
        if (typeof (item.Language) === 'number') {
          let price = item.Price.replaceAll(',', '')
          formData.append(`ActivityGroupLanguage[${index}].Language`, item.Language)
          formData.append(`ActivityGroupLanguage[${index}].Title`, item.Title)
          formData.append(`ActivityGroupLanguage[${index}].Description`, item.Description)
          formData.append(`ActivityGroupLanguage[${index}].Price`, price)
          formData.append(`ActivityGroupLanguage[${index}].PurchaseDescription`, item.PurchaseDescription)
        }
      })

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.activitygroup.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
          })
    },
    addActivityGroupLanguage() {
      this.Form.ActivityGroupLanguage.push({ Title: null, Language: null })
    },
    removeActivityGroupLanguage(index) {
      this.ActivityGroupLanguageRemoveId = index
    },
    confirmActivityGroupLanguage() {
      this.Form.ActivityGroupLanguage.splice(this.ActivityGroupLanguageRemoveId, 1)
      this.ActivityGroupLanguageRemoveId = null
    },
    cancelActivityGroupLanguage() {
      this.ActivityGroupLanguageRemoveId = null
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
